import React, { Component, CSSProperties } from 'react'
import { Theme } from '@bdfx/mergado-ui-kit';

import { GradientDefs } from "shape-edit/forms/fields";
import CircleTextShape from 'shape-entities/types/CircleTextShape';
import StrokeUnderlayerFilter, { getStrokeUnderlayerFilterId, strokeUnderlayerFilterUrl } from 'svg-text-utils/StrokeUnderlayerFilter';


interface Props {
    data: CircleTextShape
}

class CircleTextSvg extends Component<Props> {
    underlayerFilterId = getStrokeUnderlayerFilterId()

    render() {
        const shapeObject: CircleTextShape = this.props.data
        const isShadow = shapeObject.shadow_color && shapeObject.shadow_sigma
        const width = shapeObject.width

        const textColor = shapeObject.text_color ? shapeObject.text_color : 'none'

        const textStyle: CSSProperties = {
            fontFamily: `"${shapeObject.text_fontfamily}","Unicode-BMP-Fallback-SIL"`,
            fontSize: `${shapeObject.text_fontsize}px`,
            stroke: shapeObject.text_stroke_color && shapeObject.text_stroke_width ? `${shapeObject.text_stroke_color}` : undefined,
            strokeWidth: shapeObject.text_stroke_color && shapeObject.text_stroke_width ? `${shapeObject.text_stroke_width}` : undefined,
            letterSpacing: shapeObject.letter_spacing ? `${shapeObject.letter_spacing}px` : undefined,
            pointerEvents: 'fill',
        }

        const isStrokeUnderlayer = !!shapeObject.text_stroke_underlayer && !!shapeObject.text_stroke_color && !!shapeObject.text_stroke_width

        //text height nebo fontsize:
        //const { w, h } = getStringWidthAndHeight(shapeObject.text_content ? shapeObject.text_content : '\xA0', textStyle);  //get space width and line height

        const r = .5 * (width - .5*shapeObject.text_fontsize) - shapeObject.stroke_width
        const twoR = 2 * r

        const arcDirection = shapeObject.text_direction ? '1 0,1' : '0 1,0'
        const suffix = shapeObject.text_direction ? 'counter-clockwise' : 'clockwise'

        const d = `M 0,0 m-${r},0 a${r},${r} ${arcDirection} ${twoR},0 a${r},${r} ${arcDirection} -${twoR}, 0`;

        return (
            <g className="draggable">
                {isShadow &&
                    <filter id={`shadow-${shapeObject.index}`} width="200%" height="200%" y="-50%" x="-50%">
                        <feDropShadow
                            dx={shapeObject.shadow_xoffset}
                            dy={shapeObject.shadow_yoffset}
                            stdDeviation={shapeObject.shadow_sigma}
                            floodColor={shapeObject.shadow_color}
                            floodOpacity={1 - shapeObject.shadow_opacity / 100}
                        />
                    </filter>
                }

                {shapeObject.gradient_id && shapeObject.gradient &&
                    <GradientDefs gradient={shapeObject.gradient} idx={shapeObject.gradient_id} />
                }

                <defs>
                    <path id={`circle-path${shapeObject.index}-${suffix}`} strokeWidth={shapeObject.stroke_width} d={d} />
                </defs>

                <circle
                    r={.5 * width}
                    strokeWidth={shapeObject.stroke_width}
                    stroke={shapeObject.stroke_color ? shapeObject.stroke_color : 'none'}
                    fill={shapeObject.color ? shapeObject.color : 'none'}
                />

                {/* <circle r={r} strokeWidth={1} stroke={'green'} fill={'none'} />
                <circle r={innerR} strokeWidth={1} stroke={'blue'} fill={'none'} />
                <circle r={outerR} strokeWidth={1} stroke={'red'} fill={'none'} /> */}

                {shapeObject.text_content && isStrokeUnderlayer &&
                    <React.Fragment>
                        <StrokeUnderlayerFilter id={this.underlayerFilterId} strokeWidth={shapeObject.text_stroke_width} box={{ x: 0, y: 0, width, height: width }} />
                        <text
                            fill={shapeObject.text_stroke_color}
                            style={{ ...textStyle, pointerEvents: 'none' }}
                            filter={strokeUnderlayerFilterUrl(this.underlayerFilterId, shapeObject.text_stroke_width)}>
                            <textPath dominantBaseline='alphabetic' xlinkHref={`#circle-path${shapeObject.index}-${suffix}`}>{shapeObject.text_content}</textPath>
                        </text>
                    </React.Fragment>
                }

                {shapeObject.text_content &&
                    <text fill={textColor} style={isStrokeUnderlayer ? { ...textStyle, stroke: undefined, strokeWidth: undefined } : textStyle}>
                        <textPath dominantBaseline='alphabetic' xlinkHref={`#circle-path${shapeObject.index}-${suffix}`}>{shapeObject.text_content}</textPath>
                    </text>
                }
            </g>
        )
    }
}

export default CircleTextSvg
